<template>
  <div class="m_aboutgoods">
    <mt-header title="展商收藏">
      <span slot="left" @click="()=>this.$router.back()">
        <i class="iconfont icon-left"></i>
        返回
      </span>
    </mt-header>
    已约展商开发中.......
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>